// extracted by mini-css-extract-plugin
module.exports = {"profile-row":"profile_profile-row__Tvv1U","profile-row-image":"profile_profile-row-image__E78Qu","profile-row-content":"profile_profile-row-content__CtEUz"};